import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Event from '@js/components/stock_receive/stock-receive-event';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const mapToClientObject = stockReceive => {
    stockReceive.receive_date = moment(stockReceive.receive_date).format();
    return stockReceive;
};

const COMPLETED = 1;
const IN_PROGRESS = 0;

export default {
    namespaced: true,
    state: {
        stockReceive: {
            id: null,
            name: null,
            reference_id: null,
            status: null,
            outlet: {
                id: null,
                name: null,
            },
            supplier: {
                id: null,
                name: null,
            },
            stocks: [],
        },
    },
    getters: {
        stockReceive: state => state.stockReceive,
        hasFinalized: state => state.stockReceive.status == COMPLETED,
        outlet: state => state.stockReceive.outlet,
        supplier: state => state.stockReceive.supplier,
        totalPrice: (state, getters) => {
            return getters.stocks
                .map(stock => {
                    const price = parseFloat(stock.price);
                    const quantity = parseFloat(stock.receive_quantity);
                    const validPrice = !_.isNaN(price) && !_.isNaN(quantity);
                    const totalPrice = validPrice ? price * quantity : 0;

                    return parseFloat(totalPrice.toFixed(2));
                })
                .reduce((a, c) => a + c, 0);
        },
        stocks: state => state.stockReceive.stocks,
        findStockIndex: (state, getters) => stock_id => {
            return getters.stocks.findIndex(s => s.stock_id == stock_id);
        },
        completionStatus(state) {
            if (state.stockReceive.status == COMPLETED) return 'Completed';
            return 'In Progress';
        },
    },
    mutations: {
        [types.SET_STOCK_RECEIVE](state, stockReceive) {
            state.stockReceive = stockReceive;
        },

        [types.SET_STOCK_RECEIVE_ATTR](state, { key, value }) {
            state.stockReceive[key] = value;
        },

        [types.ADD_RECEIVE_STOCK](state, stock) {
            state.stockReceive.stocks.push(stock);
        },

        [types.REMOVE_RECEIVE_STOCK](state, index) {
            state.stockReceive.stocks.splice(index, 1);
        },

        [types.UPDATE_RECEIVE_STOCK](state, { index, key, value }) {
            state.stockReceive.stocks[index][key] = value;
        },
    },
    actions: {
        addReceiveStock({ commit, getters }, stockInventory) {
            let price = null;

            // find supplier price if any
            const supplierStock = getters.supplier.stocks.find(
                s => s.id == stockInventory.stock_id,
            );

            if (!_.isNil(supplierStock)) {
                price = supplierStock.pivot.cost;
            } else {
                price = stockInventory.cost;
            }

            const stock = {
                stock_id: stockInventory.stock_id,
                stock: stockInventory,
                current_quantity: stockInventory.quantity,
                receive_quantity: null,
                price,
            };

            commit(types.ADD_RECEIVE_STOCK, stock);
        },

        removeReceiveStock({ commit, getters }, stock_id) {
            const stockIndex = getters.findStockIndex(stock_id);

            if (stockIndex >= 0) {
                commit(types.REMOVE_RECEIVE_STOCK, stockIndex);
            }
        },

        setStockReceiveAttr({ commit }, { key, value }) {
            commit(types.SET_STOCK_RECEIVE_ATTR, { key, value });
        },

        updateReceiveStock({ commit, getters }, { stock_id, key, value }) {
            const index = getters.findStockIndex(stock_id);
            commit(types.UPDATE_RECEIVE_STOCK, { index, key, value });
        },

        async getStockReceive({ dispatch, commit }, id) {
            const url = Laroute.route('stock_receives.show', { id });

            startLoading(dispatch, 'fetch-stock-receive');

            try {
                const { data } = await axios.get(url);
                endLoading(dispatch, 'fetch-stock-receive');
                commit(types.SET_STOCK_RECEIVE, mapToClientObject(data));

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-stock-receive');
                throw e;
            }
        },

        async createStockReceive({ dispatch }, stockReceive) {
            const url = Laroute.route('stock_receives.store');

            startLoading(dispatch, 'save-stock-receive');

            try {
                const { data } = await axios.post(url, stockReceive);
                endLoading(dispatch, 'save-stock-receive');
                Event.$emit('stock-receive-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, 'save-stock-receive');
                throw e;
            }
        },

        async updateStockReceive(
            { dispatch, state, commit },
            finalized = false,
        ) {
            let url, method, loader;
            const id = state.stockReceive.id;

            url = finalized
                ? 'stock_receives.finalized'
                : 'stock_receives.update';

            method = finalized ? 'patch' : 'put';
            loader = finalized ? 'mark-received' : 'save-stock-receive';

            startLoading(dispatch, loader);

            try {
                const { data } = await axios[method](
                    Laroute.route(url, { id }),
                    state.stockReceive,
                );

                commit(types.SET_STOCK_RECEIVE, mapToClientObject(data));
                endLoading(dispatch, loader);
                Event.$emit('stock-receive-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, loader);
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock-receive.js